(function () {
  function swiperInit() {
    if (typeof destroyProductMediaSwipers === 'function') {
      destroyProductMediaSwipers();
    }
    subSliderInit(true);
    sliderInit(true);
    popupSliderInit(true);
  }

  document.addEventListener("shopify:section:load", function (e) {
    swiperInit();
  });

  swiperInit();
})();
